import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AppModalOverlayRef } from 'src/app/shared/services/app-modal.service';
import { AppConfigService } from 'src/environments/app-config.service';

@Component({
  standalone: false,
  selector: 'app-modal-transference-error',
  templateUrl: './modal-transference-error.component.html',
  styleUrls: ['./modal-transference-error.component.scss'],
})
export class ModalTransferenceErrorComponent implements OnInit, AfterViewInit {
  title = 'Erro!';
  description =
    'Não foi possível concluir a transferência. Verifique os dados e tente novamente ou entre em contato com o suporte.';

  private supportUrl = '';

  constructor(
    public dialogRef: AppModalOverlayRef<ModalTransferenceErrorComponent>,
    private appConfig: AppConfigService,
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    const data = this.dialogRef.data ?? {};
    this.title = data.title ?? this.title;
    this.description = data.description ?? data.content ?? this.description;
    this.supportUrl = this.appConfig.config?.urlSuporteB3 ?? '';
  }

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'contents');
  }

  close(): void {
    this.dialogRef.close();
  }

  onRetry(): void {
    this.dialogRef.close();
  }

  onSupport(): void {
    if (this.supportUrl) {
      window.open(this.supportUrl, '_blank');
    }
  }
}
